import NavLinks from './NavLinks';
import Logo from '../components/Logo';
import { FaTimes } from 'react-icons/fa';
import Wrapper from '../assets/wrappers/BigSidebar';
import { useDashboardContext } from '../pages/DashboardLayout';

const BigSidebar = () => {
  const { showSidebar, toggleSidebar } = useDashboardContext();
  return (
    <Wrapper>
      <div
        className={
          showSidebar ? 'sidebar-container show-sidebar' : 'sidebar-container'
        }
      >
        <div className='content'>
          <header>
          <button type='button' className='close-btn' onClick={toggleSidebar}>
            <FaTimes />
          </button> 
            {/* <Logo /> */}
          </header>
          <NavLinks isBigSidebar />
        </div>
      </div>
    </Wrapper>
  );
};

export default BigSidebar;
